import { Toggle } from '@fabric-ds/react';
import styled from 'styled-components';

export const ModalCheckbox = styled(Toggle)`
    display: inline-block;
`;

export const ModalButtonClose = styled.button`
    cursor: pointer;
    display: inline-block;
    background: transparent;
    border: none;
    padding: 8px 6px 3px 6px;
    right: 1px;
    position: absolute;
    top: 1px;

    ::before {
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='18' height='18'><path fill='currentColor' fill-rule='nonzero' d='M9 7.571L12.571 4 14 5.429 10.429 9 14 12.571 12.571 14 9 10.429 5.429 14 4 12.571 7.571 9 4 5.429 5.429 4 9 7.571z'/></svg>");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        content: '';
        display: block;
        height: 25px;
        width: 25px;
    }
`;
